import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#d32f2f", // Red from your logo
    },
    secondary: {
      main: "#000000", // Black for strong accents
    },
    background: {
      default: "#ffffff", // White background
      paper: "#f4f4f4", // Light grey for cards or sections
    },
    text: {
      primary: "#000000", // Black for primary text
      secondary: "#b0b0b0", // Grey for secondary text
    },
  },
  typography: {
    fontFamily: "'Montserrat', 'Roboto', sans-serif",
    // Perhaps use a display font for headings
    h1: {
      fontFamily: "'Bebas Neue', 'Montserrat', sans-serif",
      fontSize: "2.5rem",
      fontWeight: 700,
      textTransform: "uppercase",
    },
    h2: {
      fontFamily: "'Bebas Neue', 'Montserrat', sans-serif",
      fontSize: "2rem",
      fontWeight: 600,
      textTransform: "uppercase",
    },
    h3: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: "1.75rem",
      fontWeight: 500,
    },
    h4: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    body1: {
      fontSize: "1rem",
      color: "#000000",
    },
    body2: {
      fontSize: "0.9rem",
      color: "#666666",
    },
    button: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 700,
      textTransform: "uppercase",
    },
  },
});

export default theme;
